import { gql } from "@apollo/client";
import { DetailsId } from "~/EasyProjects/Details/DetailsId";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";

export type TaskResponse = { taskById: { spaceId: number } };
export type ProjectResponse = { projectById: { spaceId: number } };
export type FormResponse = { form: { spaceId: number } };

export const getSpaceByDetailsId = (details: DetailsId) => {
    if (details.entity === "Task") {
        return getSpaceIdByTask(details.id);
    }

    if (details.entity === "Project") {
        return getSpaceIdByProject(details.id);
    }

    if (details.isForm && details.id > 0 /* ignore creation */) {
        return getSpaceIdByForm(details.id);
    }
};

const getSpaceIdByTask = async (taskId: number) => {
    const { data } = await OAuthClient.graphql<TaskResponse>(appUrls.task.graphql, {
        query: gql`
                query {
                    taskById(id: ${taskId}) {
                        spaceId
                    }
                }
            `,
        variables: { id: taskId },
    });
    return data?.taskById?.spaceId;
};

export const getSpaceIdByProject = (projectId: number) => {
    return OAuthClient.graphql<ProjectResponse>(appUrls.task.graphql, {
        query: gql`
                query {
                    projectById(id: ${projectId}) {
                        spaceId
                    }
                }
            `,
    }).then(result => result.data?.projectById?.spaceId);
};

export const getSpaceIdByForm = (formId: number) => {
    return OAuthClient.graphql<FormResponse>(appUrls.forms.graphql, {
        query: gql`
                query {
                    form: byId(id: ${formId}) {
                        spaceId
                    }
                }
            `,
    }).then(result => result.data?.form?.spaceId);
};
